module.exports = __webpack_public_path__ + "static/media/gc-submitted.f77fa4d4.svg";